import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MarkdownResponse = ({ message }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: (props) => <h1 className="font-semibold text-lg mb-2" {...props} />,
        h2: (props) => (
          <h2 className="font-semibold text-base mt-3 mb-1" {...props} />
        ),
        h3: (props) => (
          <h3 className="font-semibold text-base mt-2 mb-1" {...props} />
        ),
        p: (props) => <p className="mb-1" {...props} />,
        a: ({ href, children, ...props }) => {
          const isExternal =
            typeof href === "string" && /^https?:\/\//i.test(href);

          return (
            <a
              href={href}
              {...props}
              className={[
                "underline underline-offset-2 decoration-1",
                "text-blue-600 hover:text-blue-800",
                "break-words",
                props.className || "",
              ].join(" ")}
              target={isExternal ? "_blank" : undefined}
              rel={isExternal ? "noopener noreferrer" : undefined}
            >
              {children}
            </a>
          );
        },
      }}
    >
      {message.replace(/\n{3,}/g, "\n\n")}
    </ReactMarkdown>
  );
};

export default MarkdownResponse;
